import NBType, { InferType } from '@netbase/nb-type'
import { InsightCount } from './action/InsightCountSchema'
import { AnnotatedMetricResultWith } from './AnnotatedMetricResultSchema'
import { PivotResult } from './PivotResultSchema'
import { SideBySideResult } from './SideBySideResultSchema'
import ServiceResultEntrySchema, { ServiceResultEntryWith } from './ServiceResultEntrySchema'
import { DocumentRetrievalResult } from './DocumentRetrievalResultSchema'
import { PostMetric } from './PostMetricSchema'

const ServiceResultSchema = NBType.object().shape('ServiceResultSchema', {
  /* @prop */
  lastUpdateTime: NBType.number(),
  /* @prop */
  realtime: NBType.boolean(),
  /* @prop */
  results: NBType.array().of(ServiceResultEntrySchema)
  /* END */
})
export default ServiceResultSchema
// RESERVE BELOW
export type ServiceResult = InferType<typeof ServiceResultSchema>
export type EntryData =
  | InsightCount
  | AnnotatedMetricResultWith
  | PivotResult
  | SideBySideResult
  | DocumentRetrievalResult
  | PostMetric

export type ServiceResultWith<T> = Omit<ServiceResult, 'results'> & {
  results: ServiceResultEntryWith<T>[]
}
